import { Record } from 'immutable';
import { sendHeartbeatActions } from './heartbeat.actions';
import * as api from '../../api';

export const HeartbeatState = Record({
  sendState: api.ApiCallState({}),
});

export const heartbeatReducer = (initialState = new HeartbeatState({}), action) => {
  const state = initialState.set('sendState',
    api.apiCallReducer(initialState.get('sendState'), action, sendHeartbeatActions));

    switch(action.type) {
      default: return state;
    }
}



// WEBPACK FOOTER //
// src/auth/heartbeat-system/heartbeat.reducer.js